module.exports = __webpack_public_path__ + "static/media/nike-like-a-lioness-georgia.49f41379.gif";